module.exports = __webpack_public_path__ + "img/bg.14337e32.gif";